/**
 * @module web/store
 * @private
 */

let sessionId = null;

/**
 * Returns a current sessionId to be sent to playback analytics and error reports if needed. It will be stored and searched in memory.
 * @returns {Number} - A stored session id found in memory.
 * @public
 */
const get = function() {
  return (sessionId === null && (sessionId = Math.random())) || sessionId;
};

/**
 * Resets sessionId value in order to be able to retrieve a different ID per content playback session.
 */
const reset = function() {
  sessionId = null;
};

export default { get, reset };
